
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
    name: 'ToggleButton',
    emits: ['update:isActive'],
    props: {
        initialValue: {
            type: Boolean,
            required: true
        }
    },
    setup(props, { emit }) {

        const isActive = ref(props.initialValue);

        const backgroundStyles = computed(() => {
        return {
            'active': isActive.value,
            'inactive': !isActive.value,
        };
        });

        const indicatorStyle = computed(() => {
            return { 
              transform: isActive.value ? 'translateX(100%)' : 'translateX(0)' };
        });

        const toggle = () => {
            emit('update:isActive', isActive.value = !isActive.value);
        }

        return { backgroundStyles, indicatorStyle, toggle, isActive }
    }
})
